import { emulatorScreen, mobileScreen } from "../utils/styleUtils";

const styles = (theme) => ({

  AppContainer: {
    display: 'flex',
    paddingTop: "2%",
    fontFamily: "Rubik",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {

    },
  },
  innerContainer: {
    width: "35%",
    paddingLeft: "10%",
    paddingRight: "5%",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      paddingLeft: "6%",
      width: "40%",
    },
  },
  leftContainer: { 
    display: "flex",
    justifyContent: "flex-start",
    flexDirection: "column",
    position: "relative",
    paddingLeft: "20%",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      paddingLeft: "0%",
    },
  },
  headingContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "flex-start",
    backgroundColor: "#fff",
    fontFamily: "Oswald",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      width: "95%",
    },
  },
  headingText1: {
    color: "#003e4c",
    fontSize: 24,//step >=  2 ? 20 : 24,
    textAlign: "left",
    // paddingLeft: 15,
    margin: 10,//step <  2 && 10
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      margin: 1,
      paddingLeft: 5,
    },
  },
  headingText2: {
    color: "#003e4c",
    fontSize: 20,
    textAlign: "left",
    paddingLeft: 15,
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      fontSize: 12,
      paddingLeft: 10,
    },
  },

  answerIconsContainer: {
    marginTop: 20,
    paddingLeft: "20%",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      marginTop: 0,
      paddingLeft: "0%",
    },
  },
  innerAnswerContainer: {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column"
  },
  crossIcon: {
    height: 18,
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      height: 12,
    },
  },
  wrongLabelText: {
    fontSize: 13,
    fontWeight: 500,
    float: "left",
    color: "red",
    paddingLeft: 10,
    fontFamily: "Rubik",
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      fontSize: 10,
      paddingLeft: 5,
    },
  },
  Icon: {
    height: 50,
    float: 'left',
    marginTop: '10px',
    [emulatorScreen(theme)]: {},
    [mobileScreen(theme)]: {
      height: 30,
      marginTop: 10,
    },
  },
  submitContainer: {
    display: 'flex', width: 250, cursor: "pointer", justifyContent: "space-between", marginTop: 90, marginLeft: "-10%",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      width: "40%",
      marginTop: 1,
    },
  },
  submitButton: {
    padding: "10px 20px",
    // marginTop: 90,
    fontSize: 24,
    fontWeight: 600,
    border: "none",
    float: "left",
    cursor: "pointer",
    fontFamily: "Oswald",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      // marginTop: 40,
      fontSize: 16,
      padding: "5px 8px",
      margin: 2
    },
  },

  nextButton: {
    padding: "8px 30px",
    // marginTop: 90,
    fontSize: 28,
    fontWeight: 600,
    border: "none",
    float: "left",
    cursor: "pointer",
    fontFamily: "Oswald",
    [emulatorScreen(theme)]: {

    },
    [mobileScreen(theme)]: {
      // marginTop: 40,
      fontSize: 18,
      padding: "5px 10px",
      margin: 2
    },
  },
});
export default styles;
